import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserState } from 'src/app/_shared/state/user.state';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-sent-mail',
  templateUrl: './sent-mail.component.html',
  styleUrls: ['./sent-mail.component.scss'],
})
export class SentMailComponent implements OnInit {
  @ViewChild('emailContent') emailContent: ElementRef;

  onDestroyNotifier$ = new Subject();
  sentMailDataSheetValue = false;
  user: any;
  clientDetails: any;
  sentMailData: any;
  fileList = [];
  hasAttachments: boolean = false;

  constructor(
    private clientDashboardService: ClientDashboardService,
    private clientDashboardState: ClientDashboardState,
    private renderer: Renderer2,
    private userState: UserState
  ) {}

  ngOnInit(): void {
    this.clientDashboardState.openSentMailDataSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.sentMailDataSheetValue = status;
    });
    this.clientDashboardState.activeSentMail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data: any) => {
      this.sentMailData = data;

      this.sentMailData.attachmentList.forEach((element: any) => {
        this.fileList.push(element);
      });
    });
    this.clientDashboardState.activeClientDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      this.clientDetails = res;
    });
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((userDetails) => {
      this.user = userDetails;
    });
  }
  ngAfterViewInit() {
    this.renderer.setProperty(this.emailContent.nativeElement, 'innerHTML', this.sentMailData.body);
  }

  downloadFile(id) {
    let params = {
      id: id,
      investorId: this.clientDetails._id,
    };
    this.clientDashboardService
      .downloadAttachment(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {});
  }

  closeSentMailSheet() {
    this.sentMailDataSheetValue = false;
    this.clientDashboardState.openSentMailDataSheetValue = false;

    this.fileList = [];
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
